import Dialog from '$tablet-app/src/app/components/Dialog';
import ChatScreen from '$tablet-app/src/app/screens/ChatScreen';
import React from 'react';
import { StyleSheet, useWindowDimensions } from 'react-native';
import { useStateStore } from '../../stores/useStateStore';

const ChatModal = () => {
  const closeChatScreen = useStateStore((state) => state.hideChatDialog);

  const { width, height } = useWindowDimensions();
  const isSmallScreen = width < 600 || height < 600;

  return (
    <Dialog
      onClose={closeChatScreen}
      size={isSmallScreen ? 'fullscreen' : 'xl'}
      style={
        isSmallScreen
          ? styles.fullScreenDialog
          : { minWidth: Math.min(0.95 * width, 800) }
      }
    >
      <ChatScreen onClose={closeChatScreen} minSize={isSmallScreen} />
    </Dialog>
  );
};

export default ChatModal;

const styles = StyleSheet.create({
  fullScreenDialog: {
    width: '100%',
    height: '100%',
    maxHeight: '100%',
    marginBottom: 0,
    borderRadius: 0,
  },
});
